import React from 'react'
import "./bookingresult.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp,faWeixin,} from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';
const Enquiryform = (props) => {
  const [resul, setResul] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "e913b0cc-f413-4385-bc0b-74f2007887c6");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setResul(true);
      event.target.reset();
    } else {
      alert("Error Please Resubmit This Form !")
    }
  };
  return (
    <div className="booking">

{/* LEFT FORM */}
<form className="booking__form" onSubmit={onSubmit}>
  <h2>Enquiry Form</h2>

  <div className="booking__row">
    <div>
      <label>Date</label>
      <input type="date" name="date" required />
    </div>
    <div>
      <label>No. of Adult</label>
      <input placeholder="Adult" name="No Of Travellers"/>
    </div>
  
  <div>
      <label>No. of Children</label>
      <input placeholder="Under 14" name="Children"/>
    </div>
    <div>
      <label>Country</label>
      <input placeholder="Your Country" name="Country"/>
    </div>
    </div>
  <h2>Package Details</h2>
  <div className="booking__row">
    <div>
      <label>Room Type</label>
      <select
name="Room"
      >
        <option>Deluxe (In Package)</option>
        <option>Junior Suits (Upgrade)</option>
        <option>Suits (Upgrade)</option>
        <option>Luxury (Upgrade)</option>
      </select>
    </div>
  
    <div>
      <label>Packages</label>
    <select
name="Packages"
      >
        <option>{props.title}</option>
      </select>
      </div>
    <div>
      <label>Hotel Type</label>
      <select
name="Hotel Type"
      >
         <option>Mixed 4 stars And 5 Stars (Included)</option>
        <option>3 Stars Only (Change)</option>
        <option>4 Stars Only (Change)</option>
        <option>5 Stars Only (Change)</option>
        <option>Mixed 3 stars And 4 Stars (Change)</option>
       
      </select>
    </div>
    <div>
      <label>Lunch And Dinner</label>
      <select
name="lunch&dinner"
      >
        <option>Needed</option>
        <option>Arrange By Ourselves</option>
      </select>
    </div>
    </div>
  <h2>Contact Details</h2>

  <div className="booking__row">
    <input placeholder="First Name *" required name="name"/>
    <input placeholder="Last Name" name="Last Name"/>
  </div>

  <div className="booking__row">
    <input placeholder="Phone Number (Optional)" name="Number" />
    <input placeholder="Mail *" required name="email"/>
  </div>
  <div className="booking__row">
    <input placeholder="Whatsapp (Optional)" name="whatsapp" />
    <input placeholder="Viber (Optional)" name="viber" />
   
  </div>
  <div className="booking__row">
    <input placeholder="Wexine (Optional)" name="Wechat"/>
  </div>
  <div className="booking__row">
    <input placeholder="Type What You want to tell ?" type='textarea' className='cvs'name="Message"/>
    <div>
      <label>Where Should We Contact You ?</label>
    <select
name="Where To Contact"
      >
        <option>Whatsapp</option>
        <option>Viber</option>
        <option>Wexine</option>
        <option>E-mail</option>
      </select>
      </div>
  </div>
  
  <button className="booking__btn" type="submit">Enquiry Now</button>

</form>
<div>
 {resul &&( 
  <div className='booking-lresult'>
    <div className="booking-container">
      {/* Top Navigation */}
      <div className="booking-top-nav">
        <button className="booking-back-btn" onClick={()=>setResul(false)}>
          <span className="booking-arrow">&lt;</span> Back To Page
        </button>
      </div>

      {/* Main Content Area */}
      <div className="booking-main-content">
        
        {/* Success Header Status */}
        <div className="booking-status-header">
          <div className="booking-success-icon-circle">
            <svg xmlns="http://www.w3.org/2000/svg" className="booking-svg-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="booking-status-title">Enquiry Send</h1>
          <p className="booking-status-subtitle">
           "You have successfully Send your Enquiry"
          </p>
        </div>

        {/* Receipt Wrapper Card */}
        <div className="booking-receipt-card">
          
          {/* Plan Header Segment */}
          <div className="booking-plan-badge-container">
            <div className="booking-plan-info">
              <span className="booking-crown-emoji">👑</span>
              <div>
                <h3 className="booking-plan-title">
                  Selected Packages
                  
                </h3>
                <p className="booking-plan-dates">{props.title} (Your designated Trip Expert will contact you soon.)</p>
              </div>
            </div>
          </div>

          {/* Important Procedural Notice */}
          <div className="booking-notice-box">
            <p>
              <strong>Important:</strong> All Your quiries are solve by your designated trip expert and after all things okay and want to book trip you can book directly with trip expert through messaging  and Please follow all the payment procedure strictly with your designated trip expert only who contact you from one of the listed medium below. He is always available throughout the trip if any problems arise. And Contact with him only from listed medium not through any other medium which is not listed below.
            </p>
          </div>
          {/* Designated Trip Expert Footer Segment (Normal HTML) */}
          <div className="booking-receipt-footer">
            <div className="booking-expert-profile-info">
              <div className="booking-expert-avatar-container">
                <img 
                  src="/img/company/destination expert.png" 
                  alt="Mr. Bishnu Pandey" 
                  className="booking-expert-photo"
                />
              </div>
              <div>
                <span className="booking-expert-badge">Designated Trip Expert</span>
                <h4 className="booking-expert-name">Mr. Bishnu Pandey</h4>
                <p className="booking-expert-availability">● Always Available</p>
                <div className="contact-boo">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-boo">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-boo">
            <FontAwesomeIcon icon={faEnvelope} className="icon effect" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
              </div>
            </div>

           
          </div>

        </div>

        {/* Cancel State Action Button */}

      </div>
    </div>
  </div>
)}
 </div>
{/* RIGHT CARD */}
<div className="booking__card">
  <img src={props.src} alt="room" />
</div>

</div>
  )
}

export default Enquiryform